const SkeletonCard = () => (
  <div className="bg-white rounded-[28px] overflow-hidden flex flex-col animate-pulse">
    {/* Cover */}
    <div className="aspect-[16/9] bg-[#064E3B]/10" />

    {/* Content */}
    <div className="p-6 flex flex-col gap-4">
      <div className="h-5 w-24 bg-[#A7D3AF]/50 rounded-full" />
      <div className="space-y-2">
        <div className="h-5 bg-[#064E3B]/10 rounded w-full" />
        <div className="h-5 bg-[#064E3B]/10 rounded w-4/5" />
      </div>
      <div className="space-y-2">
        <div className="h-3 bg-[#064E3B]/5 rounded w-full" />
        <div className="h-3 bg-[#064E3B]/5 rounded w-5/6" />
      </div>
      <div className="flex justify-between pt-2">
        <div className="h-3 bg-[#064E3B]/10 rounded w-24" />
        <div className="h-3 bg-[#064E3B]/10 rounded w-16" />
      </div>
    </div>
  </div>
)

export default function NewsSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6" aria-busy="true">
      {[...Array(3)].map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  )
}
